import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnDestroy} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {TargetService} from '../../../target/target.service';
import {SubscriptionHandler} from '../../../utils/subscription-handler';

@Component({
  selector: 'app-ttd-partner-group-create',
  templateUrl: './ttd-partner-group-create.component.html',
  styleUrls: ['./ttd-partner-group-create.component.scss']
})
export class TtdPartnerGroupCreateComponent implements OnDestroy {
  errorMessage!: string;
  partnerGroupName = new FormControl('', Validators.required);
  private subscriptionHandler = new SubscriptionHandler();

  constructor(private targetsActions: TargetService,
              private dialogRef: MatDialogRef<TtdPartnerGroupCreateComponent>) {
  }

  ngOnDestroy() {
    this.subscriptionHandler.unsubscribe();
  }

  reset() {
    this.partnerGroupName.reset();
  }

  create() {
    this.subscriptionHandler.subscription = this.targetsActions.createTtdPartnerGroup({
      name: this.partnerGroupName.value
    }).subscribe({
      next: () => {
        this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = error.error.message;
      }
    });
  }
}
